const AIRCRAFT_MAP = new Map<string, { name: string; commonName: string }>([
  // Airbus A220 family
  ["BCS1", { name: "Airbus A220-100", commonName: "A220-100" }],
  ["BCS3", { name: "Airbus A220-300", commonName: "A220-300" }],

  // Airbus A300/A310
  ["A306", { name: "Airbus A300-600", commonName: "A300-600" }],
  ["A30B", { name: "Airbus A300B2/B4", commonName: "A300" }],
  ["A310", { name: "Airbus A310", commonName: "A310" }],

  // Airbus A318/A319/A320/A321
  ["A318", { name: "Airbus A318", commonName: "A318" }],
  ["A319", { name: "Airbus A319", commonName: "A319" }],
  ["A19N", { name: "Airbus A319neo", commonName: "A319neo" }],
  ["A320", { name: "Airbus A320", commonName: "A320" }],
  ["A20N", { name: "Airbus A320neo", commonName: "A320neo" }],
  ["A321", { name: "Airbus A321", commonName: "A321" }],
  ["A21N", { name: "Airbus A321neo", commonName: "A321neo" }],
  ["A21L", { name: "Airbus A321LR", commonName: "A321LR" }],
  ["A21X", { name: "Airbus A321XLR", commonName: "A321XLR" }],

  // Airbus A330
  ["A332", { name: "Airbus A330-200", commonName: "A330-200" }],
  ["A333", { name: "Airbus A330-300", commonName: "A330-300" }],
  ["A338", { name: "Airbus A330-800neo", commonName: "A330-800neo" }],
  ["A339", { name: "Airbus A330-900neo", commonName: "A330-900neo" }],

  // Airbus A340
  ["A342", { name: "Airbus A340-200", commonName: "A340-200" }],
  ["A343", { name: "Airbus A340-300", commonName: "A340-300" }],
  ["A345", { name: "Airbus A340-500", commonName: "A340-500" }],
  ["A346", { name: "Airbus A340-600", commonName: "A340-600" }],

  // Airbus A350
  ["A359", { name: "Airbus A350-900", commonName: "A350-900" }],
  ["A35K", { name: "Airbus A350-1000", commonName: "A350-1000" }],

  // Airbus A380
  ["A388", { name: "Airbus A380-800", commonName: "A380" }],

  // Boeing 717
  ["B712", { name: "Boeing 717-200", commonName: "717" }],

  // Boeing 737 Classic
  ["B733", { name: "Boeing 737-300", commonName: "737-300" }],
  ["B734", { name: "Boeing 737-400", commonName: "737-400" }],
  ["B735", { name: "Boeing 737-500", commonName: "737-500" }],

  // Boeing 737 NG
  ["B736", { name: "Boeing 737-600", commonName: "737-600" }],
  ["B737", { name: "Boeing 737-700", commonName: "737-700" }],
  ["B738", { name: "Boeing 737-800", commonName: "737-800" }],
  ["B739", { name: "Boeing 737-900ER", commonName: "737-900ER" }],

  // Boeing 737 MAX
  ["B37M", { name: "Boeing 737 MAX 7", commonName: "737 MAX 7" }],
  ["B38M", { name: "Boeing 737 MAX 8", commonName: "737 MAX 8" }],
  ["B39M", { name: "Boeing 737 MAX 9", commonName: "737 MAX 9" }],
  ["B3XM", { name: "Boeing 737 MAX 10", commonName: "737 MAX 10" }],

  // Boeing 747
  ["B744", { name: "Boeing 747-400", commonName: "747-400" }],
  ["B748", { name: "Boeing 747-8", commonName: "747-8" }],

  // Boeing 757
  ["B752", { name: "Boeing 757-200", commonName: "757-200" }],
  ["B753", { name: "Boeing 757-300", commonName: "757-300" }],

  // Boeing 767
  ["B762", { name: "Boeing 767-200ER", commonName: "767-200ER" }],
  ["B763", { name: "Boeing 767-300ER", commonName: "767-300ER" }],
  ["B764", { name: "Boeing 767-400ER", commonName: "767-400ER" }],

  // Boeing 777
  ["B772", { name: "Boeing 777-200", commonName: "777-200" }],
  ["B77L", { name: "Boeing 777-200LR", commonName: "777-200LR" }],
  ["B773", { name: "Boeing 777-300", commonName: "777-300" }],
  ["B77W", { name: "Boeing 777-300ER", commonName: "777-300ER" }],
  ["B778", { name: "Boeing 777-8", commonName: "777-8" }],
  ["B779", { name: "Boeing 777-9", commonName: "777-9" }],

  // Boeing 787
  ["B788", { name: "Boeing 787-8", commonName: "787-8" }],
  ["B789", { name: "Boeing 787-9", commonName: "787-9" }],
  ["B78X", { name: "Boeing 787-10", commonName: "787-10" }],

  // Embraer
  ["E170", { name: "Embraer 170", commonName: "E170" }],
  ["E75S", { name: "Embraer 175 (Short Wing)", commonName: "E175" }],
  ["E75L", { name: "Embraer 175 (Long Wing)", commonName: "E175-E2" }],
  ["E190", { name: "Embraer 190", commonName: "E190" }],
  ["E195", { name: "Embraer 195", commonName: "E195" }],
  ["E290", { name: "Embraer 190-E2", commonName: "E190-E2" }],
  ["E295", { name: "Embraer 195-E2", commonName: "E195-E2" }],

  // ATR
  ["AT45", { name: "ATR 42-500", commonName: "ATR 42" }],
  ["AT76", { name: "ATR 72-600", commonName: "ATR 72" }],

  // Bombardier / De Havilland
  ["DH8D", { name: "De Havilland Dash 8-400", commonName: "Dash 8-400" }],
  ["CRJ2", { name: "Bombardier CRJ-200", commonName: "CRJ-200" }],
  ["CRJ7", { name: "Bombardier CRJ-700", commonName: "CRJ-700" }],
  ["CRJ9", { name: "Bombardier CRJ-900", commonName: "CRJ-900" }],
  ["CRJX", { name: "Bombardier CRJ-1000", commonName: "CRJ-1000" }],
]);

export { AIRCRAFT_MAP };

export function getAircraftDisplayName(icaoCode: string): string {
  return AIRCRAFT_MAP.get(icaoCode.toUpperCase())?.commonName ?? icaoCode;
}

export function getAircraftFullName(icaoCode: string): string {
  return AIRCRAFT_MAP.get(icaoCode.toUpperCase())?.name ?? icaoCode;
}

export const AIRCRAFT_OPTIONS: { code: string; name: string; commonName: string }[] = Array.from(
  AIRCRAFT_MAP.entries(),
)
  .map(([code, { name, commonName }]) => ({ code, name, commonName }))
  .sort((a, b) => a.commonName.localeCompare(b.commonName));
